import api from './api';

export interface VentaPendienteMaster {
  nroFormularioMaster: number;
  nroItemMaster: number;
  nroCliente?: number;
  nombreCliente?: string;
  codigoArticulo?: string;
  descripcionArticulo?: string;
  nroTipoFormularioMaster?: string | number | null;
  letraComprobanteMaster?: string;
  nroSucComprobanteMaster?: number;
  nroComprobanteMaster?: number | null;
  fechaEmisionComprobanteMaster?: string | null;
  cantidadPedida: number;
  cantidadFacturada: number;
  cantidadRemitida: number;
  cantidadCancelada: number;
  cantidadDevuelta: number;
  pendienteFacturar: number;
  pendienteEntregar: number;
  precioListaMaster?: number | null;
  precioUnitarioMaster?: number | null;
  porcDesc1Master?: number | null;
  porcDesc2Master?: number | null;
  porcDesc3Master?: number | null;
  porcDesc4Master?: number | null;
  porcDesc5Master?: number | null;
}

export interface VentaHiloComprobante {
  nroFormulario: number;
  nroItem: number;
  nroTipoFormulario?: string | number;
  fechaEmision?: string;
  letra?: string;
  nroSuc: number;
  nroComprobante?: number;
  codigoArticulo?: string;
  descripcionArticulo?: string;
  cantidad: number;
}

export interface VentaHiloResponse {
  nroFormularioMaster: number;
  nroItemMaster: number;
  comprobantes: VentaHiloComprobante[];
}

export function abrevTipoComprobanteVentaMaster(tipo?: string | number | null): string {
  const key = tipo === null || tipo === undefined || tipo === '' ? '' : String(tipo).trim();
  switch (key) {
    case '12':
      return 'PED';
    case '9':
      return 'REM';
    case '1':
    case '2':
      return 'FC';
    case '3':
      return 'NC';
    default:
      return '';
  }
}

function padComprobanteNum(n: number | null | undefined, len: number): string {
  if (n == null || Number.isNaN(Number(n))) {
    return ''.padStart(len, '0');
  }
  const v = Math.trunc(Number(n));
  return String(Math.max(0, v)).padStart(len, '0');
}

export function formatComprobanteVentaMasterDisplay(p: VentaPendienteMaster): string {
  const tipoAbrev = abrevTipoComprobanteVentaMaster(p.nroTipoFormularioMaster);
  const letraRaw = (p.letraComprobanteMaster ?? '').trim();
  const letra = letraRaw || 'X';
  const suc = p.nroSucComprobanteMaster;
  const nro = p.nroComprobanteMaster;

  const sinDatos =
    !tipoAbrev &&
    !letraRaw &&
    (suc == null || suc === undefined) &&
    (nro == null || nro === undefined);
  if (sinDatos) return '-';

  const cuerpo = `${letra}-${padComprobanteNum(suc, 5)}-${padComprobanteNum(nro, 8)}`;
  return tipoAbrev ? `${tipoAbrev} ${cuerpo}` : cuerpo;
}

export function formatComprobanteVentaHiloLine(c: VentaHiloComprobante): string {
  const tipoAbrev = abrevTipoComprobanteVentaMaster(c.nroTipoFormulario);
  const letra = (c.letra ?? '').trim() || 'X';
  const cuerpo = `${letra}-${padComprobanteNum(c.nroSuc, 5)}-${padComprobanteNum(c.nroComprobante, 8)}`;
  if (tipoAbrev) return `${tipoAbrev} ${cuerpo}`;
  if (c.nroTipoFormulario !== undefined && c.nroTipoFormulario !== null && String(c.nroTipoFormulario).trim() !== '') {
    return `[${c.nroTipoFormulario}] ${cuerpo}`;
  }
  return cuerpo;
}

export function cantidadSugeridaDesdePendienteVenta(p: VentaPendienteMaster): number {
  const pf = Number(p.pendienteFacturar) || 0;
  const pe = Number(p.pendienteEntregar) || 0;
  const m = Math.max(pf, pe);
  return m > 0 ? m : 1;
}

const ventasSeguimientoService = {
  async getPendientesMaster(nroCliente?: number, soloPendientes = true): Promise<VentaPendienteMaster[]> {
    const response = await api.get<{ items: VentaPendienteMaster[] }>('/api/VentasSeguimiento/pendientes-master', {
      params: {
        nroCliente: nroCliente || undefined,
        soloPendientes,
      },
    });
    return response.data.items || [];
  },

  async getHilo(nroFormularioMaster: number, nroItemMaster: number): Promise<VentaHiloResponse> {
    const response = await api.get<VentaHiloResponse>(
      `/api/VentasSeguimiento/hilo/${nroFormularioMaster}/${nroItemMaster}`
    );
    return response.data;
  },
};

export default ventasSeguimientoService;
